import { useState, useEffect } from 'react';
import axios, { endpoints } from 'src/utils/axios';
import { fParams, ParamsType } from 'src/utils/format-params';
import { BankAccountType } from 'src/type/bank';
import { Pagination } from 'src/type/utils';
import { omit } from 'lodash';
import { useBoolean } from './use-boolean';

export default function useBankAccountOptions() {
  const loading = useBoolean(true);
  const [options, setOptions] = useState<{ label: string; value: string; info: BankAccountType }[]>(
    []
  );

  useEffect(() => {
    (async () => {
      try {
        let accounts = Array<BankAccountType>();
        const firstChunk = await getBankAccount();

        if (!firstChunk.results.length) {
          throw new Error('No accounts found');
        }

        accounts = [...firstChunk.results];
        const paginateInfo = omit(firstChunk, 'results');

        for (let i = 1; i <= paginateInfo.totalPages; i += 1) {
          // eslint-disable-next-line no-await-in-loop
          const chunk = await getBankAccount({ lastDocId: accounts[accounts.length - 1].id });
          accounts = [...accounts, ...chunk.results];
        }

        // const accounts = await getBankAccount();

        const opt = accounts?.map((account) => ({
          label: `${account.accountName} (${account.accountNumber})`,
          value: account.id,
          info: account,
        }));

        setOptions(opt);
      } catch (error) {
        setOptions([]);
      } finally {
        loading.onFalse();
      }
    })();
  }, []);

  const getBankAccount = async (params?: ParamsType) => {
    const _params = {
      limit: 30,
      ...params,
    };

    const { data } = await axios.get<Pagination<BankAccountType>>(endpoints.adminBankAccount.get, {
      params: fParams(_params),
    });
    return data;
  };

  return { bankAccountOptions: options, isBankAccountOptionsLoading: loading.value };
}
